"use client"

import Image from "next/image"
import Link from "next/link"
import { useSession } from "next-auth/react"
import { SignInButton } from "./sub-menu"

export default function Header() {
  const { data: session, status } = useSession()
  const username = session?.user?.username

  return (
    <header className="z-40 block print:hidden bg-[rgb(0_61_96)] text-white">
      <nav>
        <section className="mx-auto flex h-[60px] min-h-full w-full max-w-6xl items-center justify-between px-3 sm:px-4 xl:px-0">
          <Link
            id="rtbf-logo"
            aria-label="RTBF Actus - Accueil"
            className="flex items-center h-full !outline-offset-[-4px] hover:opacity-90 focus:outline focus:outline-4 focus:outline-offset-2 focus:outline-white/70"
            href="/"
          >
            <Image
              src="/img/ocnc.svg"
              alt="OCNC Logo"
              className="h-9 w-auto"
              width={135}
              height={36}
            />
          </Link>

          <div className="flex items-center gap-x-4 sm:gap-x-6">
            {status === "authenticated" && username ? (
              <span className="hidden sm:inline text-sm font-bold tracking-wide">
                Bonjour {username}
              </span>
            ) : null}
            <SignInButton />
          </div>
        </section>
      </nav>
    </header>
  )
}
